import { Controller } from 'react-hook-form';
import clsx from 'clsx';
import Checkbox from 'components/Checkbox/Checkbox';

import type { IMAIroQuestionSwitcherProps } from '../intefaces/IMAIroQuestionSwitcherProps';

import styles from '../scss/DetailsQuestion.module.scss';

function MAIROQuestionSwitcher({
  question,
  control,
  setValue,
  currentValue,
  questionIndex,
  disabled,
}: IMAIroQuestionSwitcherProps) {
  return (
    <div className={styles.questionWrapper}>
      <div className={styles.name}>
        <p>{question.name}</p>
      </div>
      <div className={styles.switch}>
        <Controller
          key={`questions.${questionIndex}.answer.selectedOptionId`}
          control={control}
          name={`questions.${questionIndex}.answer.selectedOptionId`}
          defaultValue={currentValue}
          render={({ field: { onChange, value } }) => {
            const handleChange = (id: number) => {
              if (disabled) return;
              onChange(id);
              setValue(`questions.${questionIndex}.answer.selectedOptionId`, id);
            };
            return (
              <>
                {question.options.map(({ name, id }) => (
                  <Checkbox
                    key={id}
                    name={name}
                    checked={value === id}
                    value={id}
                    type="radio"
                    className={clsx(
                      styles.checkbox,
                      {
                        [styles.disabledCheckbox]: disabled,
                      },
                    )}
                    label={(
                      <div className={styles.label}>
                        <span>{name}</span>
                      </div>
                  )}
                    onChange={() => {
                      handleChange(id);
                    }}
                  />
                ))}
              </>
            );
          }}
        />
      </div>
    </div>
  );
}

export default MAIROQuestionSwitcher;
